import React, { Component, PropTypes } from 'react'

import { generateUUID } from 'utils/uuid'

import Toggle from './toggle'

class ToggleContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      checked: props.checked || false,
      id: generateUUID(),
    }

    this.handleChange = this.handleChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checked !== this.state.checked) {
      this.setState({ checked: nextProps.checked })
    }
  }

  handleChange() {
    this.setState({ checked: !this.state.checked }, this.handleChangeComplete)
  }

  handleChangeComplete() {
    if (this.props.onChange) {
      this.props.onChange(this.state.checked)
    }
  }

  render() {
    return (
      <Toggle
        checked={this.state.checked}
        id={this.state.id}
        small={this.props.small}
        onChange={this.handleChange}
      />
    )
  }
}

ToggleContainer.propTypes = {
  checked: PropTypes.bool,
  small: PropTypes.bool,
  onChange: PropTypes.func,
}

export default ToggleContainer



/** WEBPACK FOOTER **
 ** ./src/components/toggle/toggle-container.js
 **/